import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

client.interceptors.request.use((config) => {
  const token = localStorage.getItem("mpp_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const api = {
  topics: () => client.get("/topics").then((r) => r.data),
  config: () => client.get("/config").then((r) => r.data),
  modules: (status) => client.get("/modules", { params: status ? { status } : {} }).then((r) => r.data),
  module: (id) => client.get(`/modules/${id}`).then((r) => r.data),
  moduleBySlug: (slug) => client.get(`/modules/by-slug/${slug}`).then((r) => r.data),
  slides: (moduleId) => client.get(`/modules/${moduleId}/slides`).then((r) => r.data),
  questions: () => client.get("/diagnostic/questions").then((r) => r.data),
  evaluate: (payload) => client.post("/diagnostic/evaluate", payload).then((r) => r.data),
  createLead: (payload) => client.post("/leads", payload).then((r) => r.data),
  exportUrl: (moduleId, fmt) => `${API}/modules/${moduleId}/export/${fmt}`,

  login: (email, password) => client.post("/auth/login", { email, password }).then((r) => r.data),
  register: (email, password, name) => client.post("/auth/register", { email, password, name }).then((r) => r.data),
  me: () => client.get("/auth/me").then((r) => r.data),

  createModule: (data) => client.post("/admin/modules", data).then((r) => r.data),
  updateModule: (id, data) => client.put(`/admin/modules/${id}`, data).then((r) => r.data),
  deleteModule: (id) => client.delete(`/admin/modules/${id}`).then((r) => r.data),
  reorderModules: (ids) => client.post("/admin/modules/reorder", { ids }).then((r) => r.data),
  createSlide: (data) => client.post("/admin/slides", data).then((r) => r.data),
  updateSlide: (id, data) => client.put(`/admin/slides/${id}`, data).then((r) => r.data),
  deleteSlide: (id) => client.delete(`/admin/slides/${id}`).then((r) => r.data),
  reorderSlides: (moduleId, ids) => client.post(`/admin/modules/${moduleId}/slides/reorder`, { ids }).then((r) => r.data),
  leads: () => client.get("/admin/leads").then((r) => r.data),
  toolbox: () => client.get("/admin/toolbox").then((r) => r.data),
  updateToolbox: (modes) => client.put("/admin/toolbox", { modes }).then((r) => r.data),
  csf: () => client.get("/admin/csf").then((r) => r.data),
  updateCsf: (content) => client.put("/admin/csf", { content }).then((r) => r.data),

  uploadImage: (file) => {
    const fd = new FormData();
    fd.append("file", file);
    return client.post("/admin/upload", fd, { headers: { "Content-Type": "multipart/form-data" } })
      .then((r) => `${BACKEND_URL}${r.data.url}`);
  },
  coachPersonas: () => client.get("/admin/coach/personas").then((r) => r.data),
  productCases: () => client.get("/toolbox/product-cases").then((r) => r.data),
  caseFichePdf: (id) => client.get(`/toolbox/cases/${id}/pdf`, { responseType: "blob" }).then((r) => r.data),
  recommend: (situation) => client.post("/toolbox/recommend", { situation }).then((r) => r.data),
  transcribeAudio: (blob) => {
    const fd = new FormData();
    fd.append("file", blob, "audio.webm");
    return client.post("/toolbox/transcribe", fd, { headers: { "Content-Type": "multipart/form-data" } }).then((r) => r.data.text);
  },
  academy: () => client.get("/toolbox/academy").then((r) => r.data),
  academyAudio: (lessonId) => client.post(`/toolbox/academy/${lessonId}/audio`).then((r) => `${BACKEND_URL}${r.data.url}`),
  coachStart: (persona_id, language, case_id) => client.post("/admin/coach/start", { persona_id, language, case_id }).then((r) => r.data),
  coachReplyText: (session_id, text) => client.post("/admin/coach/reply-text", { session_id, text }).then((r) => r.data),
  coachReplyAudio: (session_id, blob) => {
    const fd = new FormData();
    fd.append("session_id", session_id);
    fd.append("file", blob, "audio.webm");
    return client.post("/admin/coach/reply-audio", fd, { headers: { "Content-Type": "multipart/form-data" } }).then((r) => r.data);
  },
  coachDebrief: (session_id) => client.post("/admin/coach/debrief", { session_id }).then((r) => r.data),
  coachProgress: () => client.get("/admin/coach/progress").then((r) => r.data),
  adminActivity: () => client.get("/admin/activity").then((r) => r.data),
  activityDetail: (vid) => client.get(`/admin/activity/${vid}`).then((r) => r.data),
  activityCardPdf: (vid) => client.get(`/admin/activity/${vid}/carte`, { responseType: "blob" }).then((r) => r.data),
  emailCard: (vid) => client.post(`/admin/activity/${vid}/carte/email`).then((r) => r.data),
  pubVideo: (fmt) => client.get(`/admin/pub-video/${fmt}`, { responseType: "blob" }).then((r) => r.data),
  spotVideo: (fmt) => client.get(`/admin/spot-video/${fmt}`, { responseType: "blob" }).then((r) => r.data),
  spotShort: (fmt) => client.get(`/admin/spot-short/${fmt}`, { responseType: "blob" }).then((r) => r.data),
  trajectoire: (fmt) => client.get(`/admin/trajectoire/${fmt}`, { responseType: "blob" }).then((r) => r.data),

  studioList: () => client.get("/admin/studio/productions").then((r) => r.data),
  studioGet: (id) => client.get(`/admin/studio/productions/${id}`).then((r) => r.data),
  studioCreate: (data) => client.post("/admin/studio/productions", data).then((r) => r.data),
  studioDelete: (id) => client.delete(`/admin/studio/productions/${id}`).then((r) => r.data),
  studioDuplicate: (id) => client.post(`/admin/studio/productions/${id}/duplicate`).then((r) => r.data),
  studioUploadMedia: (id, file) => {
    const fd = new FormData();
    fd.append("file", file);
    return client.post(`/admin/studio/productions/${id}/media`, fd, { headers: { "Content-Type": "multipart/form-data" } }).then((r) => r.data);
  },
  studioPrepare: (id) => client.post(`/admin/studio/productions/${id}/prepare`).then((r) => r.data),
  studioSaveDossier: (id, data) => client.put(`/admin/studio/productions/${id}/dossier`, data).then((r) => r.data),
  studioApprove: (id) => client.post(`/admin/studio/productions/${id}/approve`).then((r) => r.data),
  studioBuildBible: (id) => client.post(`/admin/studio/productions/${id}/bible`).then((r) => r.data),
  studioSaveBible: (id, bible) => client.put(`/admin/studio/productions/${id}/bible`, { bible }).then((r) => r.data),
  studioCharPack: (id, cid) => client.post(`/admin/studio/productions/${id}/characters/${cid}/pack`).then((r) => r.data),
  studioBuildEpisode: (id, idx) => client.post(`/admin/studio/productions/${id}/episodes/${idx}/storyboard`).then((r) => r.data),
  studioGenerate: (id) => client.post(`/admin/studio/productions/${id}/generate`).then((r) => r.data),
  studioVideo: (id, edition) => client.get(`/admin/studio/productions/${id}/video/${edition}`, { responseType: "blob" }).then((r) => r.data),
  studioExport: (id) => client.get(`/admin/studio/productions/${id}/export`, { responseType: "blob" }).then((r) => r.data),
  studioDiscover: (file, universe = "Trajectoire") => {
    const fd = new FormData();
    fd.append("file", file);
    fd.append("universe", universe);
    return client.post(`/admin/studio/discover`, fd, { headers: { "Content-Type": "multipart/form-data" } }).then((r) => r.data);
  },
  studioGetSettings: () => client.get("/admin/studio/settings").then((r) => r.data),
  studioSaveSettings: (data) => client.put("/admin/studio/settings", data).then((r) => r.data),
};
